import {
    // FILE_UPLOAD,
    CREATE_ADMIN_POLICIES_PROCEDURES,
    RETRIEVE_ADMIN_POLICIES_PROCEDURES,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_POLICIES_PROCEDURES,
    UPDATE_ADMIN_POLICIES_PROCEDURES,
    DELETE_ADMIN_POLICIES_PROCEDURES,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminPoliciesProcedures from "../service/AdminPoliciesProcedures";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminPoliciesProcedures.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminPoliciesProcedures.create(data);
        dispatch({
            type: CREATE_ADMIN_POLICIES_PROCEDURES,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminPoliciesProcedures.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_POLICIES_PROCEDURES,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminPoliciesProcedures.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_POLICIES_PROCEDURES,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminPoliciesProcedures.update(data);
        dispatch({
            type: UPDATE_ADMIN_POLICIES_PROCEDURES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminPoliciesProcedures.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_POLICIES_PROCEDURES,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminPoliciesProcedures.trash(data);
        dispatch({
            type: DELETE_ADMIN_POLICIES_PROCEDURES,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};